import React from "react";

import Dropdown from '../../CommonUtils/Dropdown'

const MessageA13 = (props) => {
  return <Dropdown {...props} />;
};

export default MessageA13;
